import { memo, useMemo } from "react"
import Icon from "../../Icon"
import { ICON } from "../../Icon/data"

import './index.scss'
import { COLOR } from "../../../data/variables"

type Toggle = {
  toggled: boolean
  onInput: (newValue: boolean) => void
  size: 'l' | 's'
}

const Toggle = memo(({ toggled, onInput, size = 'l' }: Toggle) => {
  const classes = useMemo(() => {
    const classArr = [`size-${size}`]
    if (toggled) classArr.push('toggled')
    return classArr
  }, [toggled, size])

  return (
    <div
      className={`Toggle ${classes.join(' ')}`}
      role="button"
      tabIndex={0}
      onClick={() => onInput(!toggled)}
    >
      <div className="Toggle__circle">
        {toggled && size === 's' && (
          <Icon icon={ICON.CHECKMARK} color={toggled ? COLOR.GREEN_50 : COLOR.GRAY_60} />
        )}
      </div>
    </div>
  )
})

export default Toggle
